/*
 * Keeps the add-to-cart price capsule in step with the selected Kaching
 * bundle card. Read-only: it never touches the Kaching app, it mirrors the
 * price text Kaching already renders on the selected card.
 *
 * One MutationObserver on <product-info> covers every trigger: Kaching
 * flipping its --selected class, Kaching rewriting a card price after a
 * colour change, and Dawn re-rendering the buy buttons. Work is batched to
 * one sync per animation frame.
 */
(function () {
  function sync() {
    var cap = document.querySelector('[data-miyego-atc-cap]');
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (!cap || !sel) return;
    var now = sel.querySelector('.kaching-bundles__bar-price');
    var was = sel.querySelector('.kaching-bundles__bar-full-price');
    if (!now) return;
    // Whole-unit currencies (data-whole, see snippets/miyego-whole-currencies.liquid): "399,00 kr" -> "399 kr".
    var whole = cap.hasAttribute('data-whole');
    var clean = function (t) { return whole ? t.replace(/(\d)[.,]00(?!\d)/g, '$1') : t; };
    var nowText = clean(now.textContent.trim());
    var wasText = was ? clean(was.textContent.trim()) : '';
    var b = cap.querySelector('[data-cap-now]');
    var s = cap.querySelector('[data-cap-was]');
    if (b && b.textContent !== nowText) b.textContent = nowText;
    if (wasText && wasText !== nowText) {
      if (!s) {
        s = document.createElement('s');
        s.setAttribute('data-cap-was', '');
        cap.insertBefore(s, cap.firstChild);
      }
      if (s.textContent !== wasText) s.textContent = wasText;
    } else if (s) {
      s.remove();
    }

    // The price line above the ticks must agree with the capsule, or the
    // buy box shows two different prices after a bundle is picked.
    var price = document.querySelector('.product__info-container .price.price--on-sale');
    if (price && wasText && wasText !== nowText) {
      var sale = price.querySelector('.price__sale .price-item--sale');
      var reg = price.querySelector('.price__sale .price-item--regular');
      if (sale && sale.textContent.trim() !== nowText) sale.textContent = nowText;
      if (reg && reg.textContent.trim() !== wasText) reg.textContent = wasText;
    }
  }

  // Labels and currencies differ per market ("PŘIDAT DO KOŠÍKU", "1 250 Kč"),
  // so no breakpoint fits all: drop the struck price only when the row overflows.
  function fit() {
    var cap = document.querySelector('[data-miyego-atc-cap]');
    var btn = cap && cap.closest('button');
    if (!btn) return;
    btn.classList.remove('is-tight');
    if (btn.scrollWidth > btn.clientWidth + 1) btn.classList.add('is-tight');
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
      fit();
    });
  }

  function init() {
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'attributes' && r.target.tagName === 'BUTTON') continue;
        schedule();
        return;
      }
    }).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    window.addEventListener('resize', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
